import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectUserInfo, logout } from "../Redux/slices/authSlice";
import house_icon from "../images/icons/house-solid.svg";
import dashboard_icon from "../images/icons/dashboard-svgrepo-com.svg";
import settings_icon from "../images/icons/gear-solid.svg";
import members_icon from "../images/icons/group.png";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);

  const menuItems = [
    {
      name: "Home",
      icon: <img src={house_icon} className="w-4 h-4" />,
      path: "/",
    },
    {
      name: "Start Monitoring",
      icon: <img src={dashboard_icon} className="w4 h-4" />,
      path: "/integrations/listing",
    },
    // {
    //   name: "Members",
    //   icon: <img src={members_icon} className="w-5 h-5" />,
    //   path: "/memberslisting",
    // },
    // {
    //   name: "Settings",
    //   icon: <img src={settings_icon} className="w-4 h-4" />,
    //   path: "/settings",
    // },
  ];

  const handleLogin = () => navigate("/login");
  const handleGetStarted = () => navigate("/login");
  const handleLogout = () => {
    dispatch(logout());
    navigate("/home");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black bg-opacity-80 text-white shadow-md">
      <div className="flex items-center justify-between px-12 py-4">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center">
            <span className="text-xl font-semibold bg-gradient-to-r from-blue-400 to-indigo-500 bg-clip-text text-transparent uppercase tracking-wide">Zyntegrate</span>
          </Link>
        </div>

        {/* Menu */}
        {/* <nav className="hidden md:flex gap-6 text-sm">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="hover:text-gray-300"
            >
              {item.name}
            </Link>
          ))}
        </nav> */}

        {/* Right Actions */}
        <div className="flex items-center gap-4 text-sm">
          {userInfo ? (
            <>
              <span className="hidden sm:inline">
                Welcome, {userInfo.first_name}
              </span>
              <button
                onClick={handleLogout}
                className="bg-red-500 hover:bg-red-600 text-white font-semibold px-4 py-2 rounded-md transition"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <button onClick={handleLogin} className="hover:text-gray-300 transition">
                Sign in
              </button>
              <button onClick={handleGetStarted} className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-md transition">
                Get Started
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;